<template>
  <div class="home">
    <Carousel />
    
    <!-- 关于我们 -->
    <section id="company-intro" class="about-intro-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title animate-fade-in-up">关于三体星云</h2>
          <!-- <p class="section-subtitle animate-fade-in-up">以科技创新赋能产业 成为用户可信赖的数字化运营服务商</p> -->
          <p class="section-subtitle animate-fade-in-up">以科技创新赋能产业 成为用户可信赖的数字化运营服务商</p>
        </div>
        <!-- <h2 class="section-title">关于三体星云</h2> -->
        <div class="about-intro-content">
          <div class="about-intro-text animate-slide-in-left">
            <!-- <div class="about-intro-subtitle">关于三体星云</div> -->
            <!-- <div class="about-intro-subtitle">以科技创新赋能产业 成为用户可信赖的数字化运营服务商</div> -->
            <!-- <h2 class="about-intro-title">以科技创新赋能产业 成为用户可信赖的数字化运营服务商</h2> -->
             <div>
               <p class="about-intro-description">
                 三体星云是一家聚焦客户的信息化创新需求，提供以大数据挖掘与分析技术为核心的专业技术服务商、基于软件定义的数据中心解决方案、下一代网络安全管理咨询和技术服务。 三体星云本着“成就客户 真诚热爱 开放创新 追求卓越 合作共赢”的宗旨，与福州大学计算机大数据学院和福建农林大学等高校建立产学研合作关系，汇聚国内众多优秀的技术与研发人才，为客户提供包括大数据与人工智能核心软件开发、园区数智一体化平台、企业数智平台、数字化供应链一站式管理平台、融合性数据中心构建、信创咨询规划改造、应用系统软件开发、IT基础设施运维管理、IT应用性能管理、等保咨询、差距分析、加固整改及安全运营等在内的全流程信息化解决方案。
                </p>
              </div>
              <div>
                <router-link to="/about" class="about-intro-button">了解更多 →</router-link>
              </div>
          </div>
          <div class="about-intro-video animate-slide-in-right">
            <div class="video-wrapper">
              <!-- <video 
                class="intro-video" 
                controls 
                poster="@/assets/background_img/关于三体星云视频封面.png"
              >
                <source src="" type="video/mp4">
                您的浏览器不支持视频播放。
              </video> -->
              <img
                class="company-intro-video-el"
                :src="companyIntroVideoPoster"
                alt="公司介绍"
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品中心 -->
    <section class="business-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title animate-fade-in-up">产品中心</h2>
          <p class="section-subtitle animate-fade-in-up">聚焦「安全与信创 + 智能运维 + 数据运营 + 国企数字化」四大方向，以 "全栈技术 + 全周期服务" 为核心，提供一站式数字化解决方案</p>
        </div>
        <div class="business-grid">
          <!-- 加载状态 -->
          <div v-if="coreBusinessLoading" class="business-loading">
            <div class="loading-spinner"></div>
            <p>加载中...</p>
          </div>
          <!-- 产品卡片 -->
          <div 
            v-else-if="coreBusiness.length > 0"
            v-for="(business, index) in coreBusiness" 
            :key="business.id || index"
            class="business-card-wrapper"
            :class="`animate-${business.animation}`"
            :style="{ animationDelay: `${index * 0.15}s` }"
          >
            <div class="business-card" @click="goToProductDetail(business)">
              <div class="business-card-image">
                <img :src="resolveCoreBusinessImage(business.image)" :alt="business.title" />
              </div>
              <div class="business-card-content">
                <h3 class="business-card-title">{{ business.title }}</h3>
                <div class="business-card-progress">
                  <div class="business-card-progress-bar"></div>
                </div>
                <ul class="business-card-items">
                  <li v-for="(item, itemIndex) in business.items" :key="itemIndex">{{ item }}</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 错误提示 -->
          <div v-else-if="coreBusinessError" class="business-error">
            <p>{{ coreBusinessError }}</p>
            <p class="error-hint">请确保 Node.js 服务器正在运行（端口 3000）</p>
          </div>
        </div>
      </div>
    </section>

    <!-- IT业务 -->
    <section class="it-business-section">
      <!-- <div class="it-business-background"></div> -->
      <div class="container">
        <div class="it-business-header">
          <h2 class="section-title it-business-section-title animate-fade-in-up">IT业务</h2>
          <p class="it-business-subtitle animate-fade-in-up">聚焦数字化转型、安全合规、运维管理等核心需求，提供 N+1 定制化解决方案，覆盖 "基建 - 数据 - 安全 - 国产化" 全场景，实现端到端落地。</p>
        </div>
        <div class="it-business-grid">
          <!-- 加载状态 -->
          <div v-if="achievementsLoading" class="it-business-loading">
            <div class="loading-spinner"></div>
            <p>加载中...</p>
          </div>
          <!-- IT业务面板 -->
          <div 
            v-else-if="achievements.length > 0"
            v-for="(achievement, index) in achievements" 
            :key="achievement.id || index"
            class="it-business-panel animate-fade-in-up"
            :style="{ animationDelay: `${index * 0.1}s` }"
            @click="goToITDetail(achievement)"
          >
            <div class="it-business-panel-bg" :style="{ backgroundImage: `url(${resolveAchievementImage(achievement.bgImage)})` }"></div>
            <div class="it-business-panel-overlay"></div>
            <div class="it-business-panel-content">
              <h3 class="it-business-title-vertical">{{ achievement.title }}</h3>
              <h3 class="it-business-title-horizontal">{{ achievement.title }}</h3>
              <div class="it-business-details">
                <div class="it-business-detail-item">
                  <p class="it-business-detail-text">{{ achievement.description }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 错误提示 -->
          <div v-else-if="achievementsError" class="it-business-error">
            <p>{{ achievementsError }}</p>
            <p class="error-hint">请确保 Node.js 服务器正在运行（端口 3000）</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 网络安全模块 -->
    <section class="network-security-section">
      <div class="container">
        <div class="network-security-header achievements-header">
          <h2 class="section-title achievements-section-title animate-fade-in-up">网络安全</h2>
          <p class="achievements-subtitle animate-fade-in-up">聚焦五大核心场景，打造端到端安全运营能力</p>
        </div>
        <div class="network-security-timeline">
          <!-- 加载状态 -->
          <div v-if="networkSecurityLoading" class="network-security-loading">
            <div class="loading-spinner"></div>
            <p>加载中...</p>
          </div>
          <!-- 时间线内容 -->
          <div v-else-if="networkSecurityModule.items && networkSecurityModule.items.length > 0" class="timeline-items">
            <div
              v-for="(item, index) in networkSecurityModule.items"
              :key="item.id || item.title || index"
              class="timeline-item animate-fade-in-up"
              :class="{ 'is-even': index % 2 === 1 }"
              @click="goToSecurityDetail(item)"
            >
              <div class="timeline-connector"></div>
              <div class="timeline-node">
                <img :src="resolveNetworkSecurityImage(item.image)" :alt="item.title" />
              </div>
              <div class="timeline-panel">
                <h4>{{ item.title }}</h4>
                <p>{{ item.desc }}</p>
              </div>
            </div>
          </div>
          <!-- 错误提示 -->
          <div v-else-if="networkSecurityError" class="network-security-error">
            <p>{{ networkSecurityError }}</p>
            <p class="error-hint">请确保 Node.js 服务器正在运行（端口 3000）</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 新闻动态 -->
    <section class="news-section">
      <div class="container">
        <div class="news-header">
          <h2 class="section-title news-section-title animate-fade-in-up">新闻动态</h2>
          <p class="news-subtitle animate-fade-in-up">了解行业最新资讯、公司动态及技术前沿趋势</p>
        </div>
        <div class="news-content-wrapper">
          <!-- 加载状态 -->
          <div v-if="newsListLoading" class="news-loading">
            <div class="loading-spinner"></div>
            <p>加载中...</p>
          </div>
          <!-- 新闻内容 -->
          <template v-else-if="newsList.length > 0">
          <!-- 左侧新闻大卡片 -->
          <div class="news-featured animate-slide-in-left" @click="goNewsDetail(newsList[0])">
            <div class="featured-image">
              <img :src="resolveNewsImage(newsList[0].image)" :alt="newsList[0].title" />
            </div>
            <div class="featured-content">
              <h3 class="featured-title">{{ newsList[0].title }}</h3>
              <p class="featured-summary">{{ newsList[0].summary }}</p>
            </div>
          </div>
          <!-- 右侧新闻列表 -->
          <div class="news-list-wrapper">
            <div class="news-list">
              <div 
                v-for="(newsItem, index) in newsList.slice(1)" 
                  :key="newsItem.id || index"
                class="news-item animate-slide-in-right"
                :style="{ animationDelay: `${index * 0.1}s` }"
                @click="goNewsDetail(newsItem)"
              >
                <div class="news-date">
                  <span class="date-day">{{ newsItem.date.split('-')[2] }}</span>
                  <span class="date-year-month">{{ newsItem.date.split('-')[0] }}-{{ newsItem.date.split('-')[1] }}</span>
                </div>
                <div class="news-content">
                  <h3>{{ newsItem.title }}</h3>
                  <p class="news-summary">{{ newsItem.summary }}</p>
                </div>
              </div>
            </div>
            </div>
          </template>
          <!-- 错误提示 -->
          <div v-else-if="newsListError" class="news-error">
            <p>{{ newsListError }}</p>
            <p class="error-hint">请确保 Node.js 服务器正在运行（端口 3000）</p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import Carousel from '../../components/Carousel.vue'
import axios from 'axios'

const homeProductCtx = require.context('@/assets/home/Products', false, /\.(png|jpe?g)$/)
const homeITCtx = require.context('@/assets/home/IT', false, /\.(png|jpe?g)$/)
const homeSecurityCtx = require.context('@/assets/home/Security', false, /\.(png|jpe?g)$/)
const newsImageCtx = require.context('@/assets/news_photo', false, /\.jpe?g$/)
const companyIntroVideoPoster = 'https://oss-test.i.ydacity.cn/ydacity/4c3767b06225c5aafa21b4affcf4a5ca6ed36b938a3e7a918b638c72509bd2a2.png'

export default {
  name: 'Home',
  components: {
    Carousel
  },
  data() {
    return {
      companyIntroVideoPoster,
      coreBusiness: [],
      coreBusinessLoading: false,
      coreBusinessError: null,
      achievements: [],
      achievementsLoading: false,
      achievementsError: null,
      newsList: [],
      newsListLoading: false,
      newsListError: null,
      networkSecurityModule: {
        title: '',
        subtitle: '',
        description: '',
        items: []
      },
      networkSecurityLoading: false,
      networkSecurityError: null,
    }
  },
  async mounted() {
    // 获取所有首页数据
    await Promise.all([
      this.fetchCoreBusiness(),
      this.fetchAchievements(),
      this.fetchNewsList(),
      this.fetchNetworkSecurity()
    ])
    
    // 等待轮播图显示后，再让"产品中心"部分的动画显示
    this.$nextTick(() => {
      // 延迟一段时间，确保轮播图已经显示
      setTimeout(() => {
        const businessSection = document.querySelector('.business-section')
        if (businessSection) {
          // 选择"产品中心"部分所有包含 animate- 类的元素，显示动画
          const animatedElements = businessSection.querySelectorAll('[class*="animate-"]')
          animatedElements.forEach((el) => {
            el.classList.add('is-visible')
          })
        }
      }, 800) // 延迟800ms，让轮播图先显示
    })
  },
  methods: {
    async fetchCoreBusiness() {
      try {
        this.coreBusinessLoading = true
        this.coreBusinessError = null
        const response = await axios.get('/api/home/core-business')
        if (response.data.code === 200) {
          this.coreBusiness = response.data.data
        } else {
          this.coreBusinessError = response.data.message || '获取产品中心数据失败'
          this.coreBusiness = []
        }
      } catch (error) {
        console.error('获取产品中心数据失败:', error)
        this.coreBusinessError = '网络请求失败，请检查服务器是否运行'
        this.coreBusiness = []
      } finally {
        this.coreBusinessLoading = false
      }
    },
    async fetchAchievements() {
      try {
        this.achievementsLoading = true
        this.achievementsError = null
        const response = await axios.get('/api/home/achievements')
        if (response.data.code === 200) {
          this.achievements = response.data.data
        } else {
          this.achievementsError = response.data.message || '获取IT业务数据失败'
          this.achievements = []
        }
      } catch (error) {
        console.error('获取IT业务数据失败:', error)
        this.achievementsError = '网络请求失败，请检查服务器是否运行'
        this.achievements = []
      } finally {
        this.achievementsLoading = false
      }
    },
    async fetchNewsList() {
      try {
        this.newsListLoading = true
        this.newsListError = null
        const response = await axios.get('/api/home/news')
        if (response.data.code === 200) {
          this.newsList = response.data.data.list || response.data.data
        } else {
          this.newsListError = response.data.message || '获取新闻列表失败'
          this.newsList = []
        }
      } catch (error) {
        console.error('获取新闻列表失败:', error)
        this.newsListError = '网络请求失败，请检查服务器是否运行'
        this.newsList = []
      } finally {
        this.newsListLoading = false
      }
    },
    async fetchNetworkSecurity() {
      try {
        this.networkSecurityLoading = true
        this.networkSecurityError = null
        const response = await axios.get('/api/home/network-security')
        if (response.data.code === 200) {
          this.networkSecurityModule = response.data.data
        } else {
          this.networkSecurityError = response.data.message || '获取网络安全数据失败'
          this.networkSecurityModule = {
            title: '',
            subtitle: '',
            description: '',
            items: []
          }
        }
      } catch (error) {
        console.error('获取网络安全数据失败:', error)
        this.networkSecurityError = '网络请求失败，请检查服务器是否运行'
        this.networkSecurityModule = {
          title: '',
          subtitle: '',
          description: '',
          items: []
        }
      } finally {
        this.networkSecurityLoading = false
      }
    },
    resolveCoreBusinessImage(imagePath) {
      if (!imagePath) return ''
      if (imagePath.startsWith('@Products/')) {
        const fileName = imagePath.replace('@Products/', '')
        try {
          return homeProductCtx('./' + fileName)
        } catch (e) {
          console.warn('核心业务图片未找到:', fileName, e)
          return ''
        }
      }
      return imagePath
    },
    resolveAchievementImage(imagePath) {
      if (!imagePath) return ''
      if (imagePath.startsWith('@IT/')) {
        const fileName = imagePath.replace('@IT/', '')
        try {
          return homeITCtx('./' + fileName)
        } catch (e) {
          console.warn('IT业务图片未找到:', fileName, e)
          return ''
        }
      }
      return imagePath
    },
    resolveNetworkSecurityImage(imagePath) {
      if (!imagePath) return ''
      if (imagePath.startsWith('@Security/')) {
        const fileName = imagePath.replace('@Security/', '')
        try {
          return homeSecurityCtx('./' + fileName)
        } catch (e) {
          console.warn('网络安全图片未找到:', fileName, e)
          return ''
        }
      }
      return imagePath
    },
    resolveNewsImage(imagePath) {
      if (!imagePath) return ''
      if (imagePath.startsWith('@/assets/news_photo/')) {
        const fileName = imagePath.split('/').pop()
        try {
          return newsImageCtx('./' + fileName)
        } catch (e) {
          console.warn('新闻图片未找到:', fileName, e)
          return ''
        }
      }
      // 其他情况（远程 URL 等）直接返回
      return imagePath
    },
    goNewsDetail(item) {
      if (item && item.id) {
        this.$router.push({
          path: '/news/detail',
          query: {
            id: item.id
          }
        })
      } else {
        console.warn('新闻项缺少ID，无法跳转到详情页', item)
      }
    },
    goToProductDetail(business) {
      if (!business || !business.title) {
        console.warn('产品项缺少标题，无法跳转到详情页', business)
        return
      }
      
      // 根据标题映射到对应的产品详情ID和section
      const productMapping = {
        '一站式大数据平台': { id: 'big-data-suite', section: 'big-data-platform' },
        '数字供应链一站式竞价平台': { id: 'state-asset-platform', section: 'application-center' },
        '智慧园区数智平台': { id: 'smart-park', section: 'application-center' },
        '知识图谱系统': { id: 'knowledge-graph', section: 'big-data-platform' }
      }
      
      const mapping = productMapping[business.title]
      if (mapping) {
        this.$router.push({
          path: '/products/detail',
          query: {
            id: mapping.id,
            section: mapping.section
          }
        })
      } else {
        console.warn('未找到对应的产品详情映射:', business.title)
      }
    },
    goToITDetail(achievement) {
      if (!achievement || !achievement.title) {
        console.warn('IT业务项缺少标题，无法跳转到详情页', achievement)
        return
      }
      
      // 根据标题映射到对应的IT详情ID
      const itMapping = {
        '虚拟化': 'virtualization',
        '超融合': 'hci',
        'SDDC': 'sddc',
        '智能运维管理': 'smart-ops',
        '应用性能管理': 'apm',
        'SD-WAN': 'sdwan',
        'SDN': 'sdn',
        '视频会议': 'video-conference',
        '办公自动化': 'office-automation',
        '能耗管理': 'energy-management',
        '模块化数字机房': 'modular-data-center'
      }
      
      const detailId = itMapping[achievement.title]
      if (detailId) {
        this.$router.push({
          path: '/it/detail',
          query: {
            id: detailId
          }
        })
      } else {
        console.warn('未找到对应的IT详情映射:', achievement.title)
      }
    },
    goToSecurityDetail(item) {
      if (!item || !item.title) {
        console.warn('网络安全项缺少标题，无法跳转到详情页', item)
        return
      }

      const securityMapping = {
        '网络安全': 'network-security',
        '数据安全': 'data-security',
        '国密安全': 'crypto-security',
        '工控安全': 'industrial-control',
        '安全运营': 'ai-security'
      }

      const securityId = securityMapping[item.title] || item.id
      if (securityId) {
        this.$router.push({
          path: '/security/detail',
          query: {
            id: securityId
          }
        })
      } else {
        console.warn('未找到对应的网络安全详情映射:', item.title)
      }
    }
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 20px;
}

.section-title {
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 60px;
  color: #333;
  position: relative;
  padding-bottom: 20px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  border-radius: 2px;
}

.section-subtitle {
  /* text-align: center; */
  font-size: 16px;
  color: #666;
  font-style: italic;
  opacity: 0;
  line-height: 1.8;
}

/* 关于企业介绍板块 */
.about-intro-section {
  background: 
    linear-gradient(135deg, rgba(245, 245, 245, 0.95) 0%, rgba(245, 245, 245, 0.9) 100%),
    url('../../assets/background_img/关于三体星云.png') center/cover no-repeat;
  padding: 20px 0;
  position: relative;
}

.about-intro-section .section-title {
  text-align: left;
  margin-bottom: 15px;
}

.about-intro-section .section-title::after {
  left: 0;
  transform: none;
}

.about-intro-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.about-intro-text {
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.about-intro-subtitle {
  font-size: 16px;
  color: #999999;
  font-weight: 400;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.about-intro-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 30px 0;
  line-height: 1.4;
}

.about-intro-description {
  font-size: 16px;
  color: #333333;
  line-height: 1.8;
  margin: 0 0 10px 0;
  text-indent: 2em;
}

.about-intro-button {
  display: inline-block;
  padding: 14px 32px;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  color: #ffffff;
  text-decoration: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(76, 149, 227, 0.3);
}

.about-intro-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 149, 227, 0.4);
}

.about-intro-video {
  position: relative;
  width: 100%;
}

.video-wrapper {
  position: relative;
  /* width: 100%; */
  /* padding-bottom: 56.25%; */
  /* background: #000000; */
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: center;
}

.intro-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.company-intro-video-el {
  width: 80%;
  border-radius: 30px;
  height: auto;
  object-fit: contain;
}

@media (max-width: 992px) {
  .about-intro-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .about-intro-title {
    font-size: 24px;
  }
}

@media (max-width: 768px) {
  .about-intro-section {
    padding: 60px 0;
  }

  .about-intro-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .about-intro-title {
    font-size: 20px;
  }

  .about-intro-description {
    font-size: 15px;
  }

  .about-intro-button {
    padding: 12px 28px;
    font-size: 15px;
  }
}

/* 业务介绍区域*/
.business-section {
  background: 
    /* linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.9) 100%), */
    linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.3) 100%),
    url('../../assets/background_img/产品中心.png') center/cover no-repeat;
  padding: 20px 0;
  position: relative;
}

.section-header {
  margin-bottom: 30px;
  text-align: left;
}

.business-section .section-title {
  text-align: left;
  margin-bottom: 15px;
  padding-bottom: 20px;
  font-size: 32px;
  font-weight: 700;
  /* color: #1a1a1a; */
  color: #ffffff;
}

.business-section .section-title::after {
  left: 0;
  transform: none;
}

.business-section .section-subtitle {
  text-align: left;
  font-size: 16px;
  /* color: #666; */
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
  line-height: 1.8;
  max-width: 900px;
  margin: 0;
  padding: 0;
}

.business-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  position: relative;
  z-index: 1;
}

.business-card-wrapper { display: block; }

.business-card {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 5px;
  
}

.business-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 32px rgba(76, 149, 227, 0.15);
}

.business-card-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: #f5f5f5;
  position: relative;
}

.business-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.business-card:hover .business-card-image img {
  transform: scale(1.05);
}

.business-card-content {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.business-card-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 15px 0;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.business-card-progress {
  width: 100%;
  height: 3px;
  background: #e5e5e5;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
}

.business-card-progress-bar {
  height: 100%;
  width: 20px;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  transition: width 0.6s ease;
  position: relative;
}

.business-card-progress-bar::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #4c95e3;
  box-shadow: 0 0 8px rgba(76, 149, 227, 0.6);
}

.business-card:hover .business-card-progress-bar {
  width: 100%;
}

.business-card-items {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
}

.business-card-items li {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
}

.business-card-items li::before {
  content: '·';
  position: absolute;
  left: 0;
  color: #4c95e3;
  font-size: 20px;
  line-height: 1;
  font-weight: bold;
}

.business-card-items li:last-child {
  margin-bottom: 0;
}

/* 加载状态样式 */
.business-loading {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 300px;
}

.business-loading .loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(76, 149, 227, 0.3);
  border-top-color: #4c95e3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.business-loading p {
  color: #666;
  font-size: 16px;
  margin: 0;
}

/* 错误提示样式 */
.business-error {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 300px;
  text-align: center;
  color: #ff6b6b;
  background: #f5f5f5;
  border-radius: 12px;
}

.business-error p {
  margin: 10px 0;
  font-size: 16px;
}

.business-error .error-hint {
  color: #999;
  font-size: 14px;
  margin-top: 10px;
}

/* 中等屏幕响应式 */
@media (max-width: 1200px) {
  .business-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .business-section {
    padding: 60px 0;
  }

  .business-section .section-title {
    font-size: 28px;
  }

  .business-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .business-card-image {
    height: 180px;
  }

  .business-card-content {
    padding: 20px;
  }

  .business-card-title {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .business-card-items li {
    font-size: 13px;
    margin-bottom: 8px;
  }
}

/* 新闻动态区域 */
.news-section {
  background:
    radial-gradient(circle at 20% 10%, rgba(76, 149, 227, 0.08) 0%, transparent 40%),
    radial-gradient(circle at 85% 30%, rgba(138, 43, 226, 0.06) 0%, transparent 45%),
    radial-gradient(circle at 10% 90%, rgba(0, 212, 255, 0.06) 0%, transparent 40%),
    linear-gradient(180deg, rgba(247, 249, 252, 0.95) 0%, rgba(238, 242, 247, 0.9) 100%),
    url('../../assets/background_img/新闻动态.png') center/cover no-repeat;
  padding: 20px 0;
}

.news-header {
  text-align: left;
  margin-bottom: 30px;
  position: relative;
  z-index: 1;
}

.news-subtitle {
  text-align: left;
  font-size: 16px;
  color: #666666;
  font-style: italic;
  opacity: 1;
  line-height: 1.8;
  max-width: 900px;
  margin: 0;
  position: relative;
  z-index: 1;
}

.news-section-title {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 15px 0;
  padding-bottom: 20px;
  position: relative;
  z-index: 1;
}

.news-section .section-title {
  text-align: left;
}

.news-section .section-title::after {
  left: 0;
  transform: none;
}

.news-content-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

/* 新闻加载状态样式 */
.news-loading {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 300px;
}

.news-loading .loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(76, 149, 227, 0.3);
  border-top-color: #4c95e3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.news-loading p {
  color: #666;
  font-size: 16px;
  margin: 0;
}

/* 新闻错误提示样式 */
.news-error {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 300px;
  text-align: center;
  color: #ff6b6b;
  background: #f5f5f5;
  border-radius: 12px;
}

.news-error p {
  margin: 10px 0;
  font-size: 16px;
}

.news-error .error-hint {
  color: #999;
  font-size: 14px;
  margin-top: 10px;
}

/* 左侧新闻大卡片 */
.news-featured {
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  opacity: 0;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.news-featured:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(76, 149, 227, 0.2);
}

.featured-image {
  width: 100%;
  height: 300px;
  overflow: hidden;
  background: #f5f5f5;
}

.featured-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.news-featured:hover .featured-image img {
  transform: scale(1.05);
}

.featured-content {
  padding: 30px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.featured-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 15px 0;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.featured-summary {
  font-size: 15px;
  color: #666;
  line-height: 1.8;
  margin: 0;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 右侧新闻列表 */
.news-list-wrapper {
  display: flex;
  flex-direction: column;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  justify-content: space-between;
  height: 100%;
}

.news-item {
  background: white;
  border-radius: 12px;
  padding: 18px;
  display: flex;
  gap: 18px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  border-left: 3px solid transparent;
  opacity: 0;
  cursor: pointer;
}

.news-item:hover {
  transform: translateX(8px) scale(1.01);
  box-shadow: 0 6px 20px rgba(76, 149, 227, 0.15);
  border-left-color: #4c95e3;
}

.news-date {
  flex-shrink: 0;
  width: 75px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  color: white;
  border-radius: 10px;
  padding: 12px;
  box-shadow: 0 3px 10px rgba(76, 149, 227, 0.25);
}

.date-day {
  font-size: 28px;
  font-weight: bold;
  line-height: 1;
}

.date-year-month {
  font-size: 13px;
  margin-top: 6px;
}

.news-content {
  flex: 1;
}

.news-content h3 {
  font-size: 16px;
  margin-bottom: 8px;
  color: #333;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-summary {
  color: #666;
  line-height: 1.6;
  font-size: 13px;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* IT业务展示部分*/
.it-business-section {
  position: relative;
  background: 
    /* linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.3) 100%), */
    linear-gradient(135deg, rgba(245, 245, 245, 1) 0%, rgba(245, 245, 245, 0.9) 100%),
    url('../../assets/background_img/IT业务.png') center/cover no-repeat;
  padding: 20px 0;
  overflow: hidden;
  /* padding-bottom: 0px; */
}

/* removed empty .it-business-section .container ruleset */

.it-business-header {
  text-align: left;
  margin-bottom: 30px;
  position: relative;
  z-index: 1;
  padding: 0 20px;
}

.it-business-section-title {
  font-size: 32px;
  font-weight: 700;
  /* color: #ffffff; */
  color: #1a1a1a;
  margin: 0 0 15px 0;
  padding-bottom: 20px;
  position: relative;
  z-index: 1;
  /* text-shadow: 0 0 20px rgba(76, 149, 227, 0.5); */
}

.it-business-section .section-title {
  text-align: left;
}

.it-business-section .section-title::after {
  left: 0;
  transform: none;
}

.it-business-subtitle {
  text-align: left;
  font-size: 16px;
  /* color: rgba(255, 255, 255, 0.8); */
  color: #666;
  font-style: italic;
  opacity: 1;
  line-height: 1.8;
  max-width: 900px;
  margin: 0;
  padding: 0;
  position: relative;
  z-index: 1;
}

.it-business-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(76, 149, 227, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(76, 149, 227, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  opacity: 0.3;
  animation: grid-move-it-business 20s linear infinite;
}

@keyframes grid-move-it-business {
  0% { transform: translate(0, 0); }
  100% { transform: translate(50px, 50px); }
}

.it-business-grid {
  display: flex;
  gap: 0;
  position: relative;
  z-index: 1;
  width: 100%;
  overflow: visible;
  min-height: 400px;
}

/* IT业务加载状态样式 */
.it-business-loading {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 400px;
}

.it-business-loading .loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.it-business-loading p {
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  margin: 0;
}

/* IT业务错误提示样式 */
.it-business-error {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 400px;
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
}

.it-business-error p {
  margin: 10px 0;
  font-size: 16px;
}

.it-business-error .error-hint {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin-top: 10px;
}

.it-business-panel {
  position: relative;
  height: 400px;
  flex: 1;
  min-width: 0;
  border-radius: 0;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  margin: 0;
}

.it-business-panel:first-child {
  border-radius: 16px 0 0 16px;
}

.it-business-panel:last-child {
  border-radius: 0 16px 16px 0;
}

.it-business-grid:hover .it-business-panel:not(:hover) {
  flex: 0.5;
  opacity: 0.7;
}

.network-security-section {
  background:
    /* linear-gradient(135deg, rgba(0, 0, 0, 0.65), rgba(3, 16, 42, 0.95)), */
    linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.3) 100%),
    url('../../assets/background_img/网络安全.png') center/cover no-repeat;
  padding: 20px 0 30px;
  position: relative;
  overflow: hidden;
}

.network-security-section::before,
.network-security-section::after {
  content: '';
  position: absolute;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(76, 149, 227, 0.25), transparent 60%);
}

.network-security-section::before {
  top: -80px;
  left: -40px;
}

.network-security-section::after {
  bottom: -120px;
  right: -60px;
}

.network-security-section .section-title {
  text-align: left;
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 15px;
  padding-bottom: 20px;
  position: relative;
  text-shadow: 0 0 20px rgba(76, 149, 227, 0.5);
}

.network-security-section .section-title::after {
  left: 0;
  transform: none;
  background: linear-gradient(135deg, #7bd7ff 0%, #4c95e3 100%);
}

.network-security-section .achievements-subtitle {
  color: rgba(255, 255, 255, 0.8);
  text-align: left;
  margin: 0;
  max-width: 900px;
  font-style: italic;
  line-height: 1.8;
}

.network-security-timeline {
  position: relative;
  max-width: 1600px;
  margin: 0 auto;
  margin-top: 140px;
  padding: 0 40px 0px;
  min-height: 380px;
}

/* 网络安全加载状态样式 */
.network-security-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 380px;
}

.network-security-loading .loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.network-security-loading p {
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  margin: 0;
}

/* 网络安全错误提示样式 */
.network-security-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 380px;
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
}

.network-security-error p {
  margin: 10px 0;
  font-size: 16px;
}

.network-security-error .error-hint {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin-top: 10px;
}

.timeline-items {
  position: relative;
  height: 360px;
  margin: 0 auto;
}

.timeline-item {
  position: absolute;
  width: 220px;
  text-align: center;
  bottom: 0;
  padding-bottom: 140px;
  cursor: pointer;
}

.timeline-node {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  padding: 6px;
  background: linear-gradient(135deg, rgba(123, 215, 255, 0.8), rgba(72, 161, 255, 0.5));
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.35);
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}

.timeline-node::after {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #7bd7ff;
  bottom: -28px;
  box-shadow: 0 0 15px rgba(123, 215, 255, 0.6);
}

.timeline-node img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.timeline-connector {
  position: absolute;
  left: 50%;
  width: 2px;
  background: rgba(255, 255, 255, 0.65);
  transform: translateX(-50%);
  bottom: 120px;
  top: 160px;
}

/* 第一个：线从底部中心往上到卡片（最低） */
.timeline-item:nth-child(1) .timeline-connector {
  height: 180px;
}

.timeline-item:nth-child(1) .timeline-panel {
  bottom: 140px;
}

/* 第二个：线稍短，卡片稍高，形成“M”左侧第二峰 */
.timeline-item:nth-child(2) .timeline-connector {
  height: 80px;
}

.timeline-item:nth-child(2) .timeline-panel {
  bottom: 140px;
}

/* 第三个：在线上方中间位置，形成“M”中间谷点 */
.timeline-item:nth-child(3) .timeline-connector {
  height: 210px;
}

.timeline-item:nth-child(3) .timeline-panel {
  bottom: 140px;
}

/* 其余保持与第2、1个对称，可按需再调 */
.timeline-item:nth-child(4) .timeline-connector {
  height: 80px;
}

.timeline-item:nth-child(4) .timeline-panel {
  bottom: 140px;
}

.timeline-item:nth-child(5) .timeline-connector {
  height: 180px;
}

.timeline-item:nth-child(5) .timeline-panel {
  bottom: 140px;
}

.timeline-panel {
  position: absolute;
  left: 50%;
  width: 230px;
  transform: translateX(-50%);
  /* background: rgba(255, 255, 255, 0.08); */
  /* border: 1px solid rgba(255, 255, 255, 0.12); */
  border-radius: 18px;
  /* padding: 18px 20px; */
  /* box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25); */
  z-index: 3;
}

.timeline-panel h4 {
  margin: 0 0 10px;
  font-size: 18px;
  color: #ffffff;
}

.timeline-panel p {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.7;
}

/* 移除基于 is-even 的默认上下布局，改为上面 nth-child 精细控制 */

/* X 轴定位，构成“ M ”轮廓 */
.timeline-item:nth-child(1) {
  left: 0%;
  bottom: 50%;
}
.timeline-item:nth-child(2) {
  left: 20%;
  bottom: 20%;
}
.timeline-item:nth-child(3) {
  left: 40%;
  bottom: 60%;
}
.timeline-item:nth-child(4) {
  left: 60%;
  bottom: 20%;
}
.timeline-item:nth-child(5) {
  left: 80%;
  bottom: 50%;
}

.it-business-panel:hover {
  flex: 2;
  transform: translateY(-8px);
  border-color: rgba(76, 149, 227, 0.6);
  box-shadow: 0 20px 50px rgba(76, 149, 227, 0.4);
  z-index: 10;
  opacity: 1;
}

.it-business-panel-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: transform 0.6s ease;
}

.it-business-panel:hover .it-business-panel-bg {
  transform: scale(1.1);
}

.it-business-panel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background: linear-gradient(
    135deg,
    rgba(10, 14, 39, 0.55) 0%,
    rgba(26, 31, 58, 0.45) 50%,
    rgba(15, 20, 25, 0.55) 100%
  ); */
  background-color: rgba(146, 146, 146, 0.2);
  z-index: 1;
}

.it-business-panel-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 20px;
  text-align: center;
  overflow: hidden;
}

.it-business-title-vertical {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  writing-mode: vertical-rl;
  text-orientation: upright;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  text-shadow: 0 0 20px rgba(76, 149, 227, 0.6),
               0 2px 10px rgba(0, 0, 0, 0.5);
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  z-index: 3;
  letter-spacing: 8px;
}

.it-business-panel:hover .it-business-title-vertical {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.8);
}

.it-business-title-horizontal {
  position: absolute;
  top: 30px;
  left: 30px;
  right: 30px;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 20px 0;
  padding: 0;
  text-align: left;
  text-shadow: 0 0 20px rgba(76, 149, 227, 0.6);
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
  transform: translateY(-20px);
  z-index: 3;
}

.it-business-panel:hover .it-business-title-horizontal {
  opacity: 1;
  transform: translateY(0);
}

.it-business-details {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 30px;
  transform: translateY(100%);
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
  z-index: 3;
}

.it-business-panel:hover .it-business-details {
  transform: translateY(0);
  opacity: 1;
}

.it-business-detail-item {
  margin-bottom: 20px;
  text-align: left;
}

.it-business-detail-item:last-child {
  margin-bottom: 0;
}

.it-business-detail-label {
  font-size: 13px;
  font-weight: 700;
  color: rgba(76, 149, 227, 0.9);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 10px;
  display: inline-block;
  padding: 4px 12px;
  background: rgba(76, 149, 227, 0.15);
  border-radius: 12px;
  border: 1px solid rgba(76, 149, 227, 0.3);
}

.it-business-detail-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.8;
  margin: 0;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

/* Animista 动画效果 */
.animate-fade-in-up {
  opacity: 0;
  transform: translateY(40px);
  will-change: transform, opacity;
}

.animate-fade-in-up.is-visible {
  animation: fade-in-up 0.8s ease-out forwards;
}

.animate-slide-in-left {
  opacity: 0;
  transform: translateX(-60px);
  will-change: transform, opacity;
}

.animate-slide-in-left.is-visible {
  animation: slide-in-left 0.8s ease-out forwards;
}

.animate-slide-in-right {
  opacity: 0;
  transform: translateX(60px);
  will-change: transform, opacity;
}

.animate-slide-in-right.is-visible {
  animation: slide-in-right 0.8s ease-out forwards;
}

.animate-zoom-in {
  opacity: 0;
  transform: scale(0.7);
  will-change: transform, opacity;
}

.animate-zoom-in.is-visible {
  animation: zoom-in 0.8s ease-out forwards;
}

.animate-scale-in-center {
  opacity: 0;
  transform: scale(0.5);
  will-change: transform, opacity;
}

.animate-scale-in-center.is-visible {
  animation: scale-in-center 0.8s ease-out forwards;
}

.animate-fade-in {
  opacity: 0;
  will-change: opacity;
}

.animate-fade-in.is-visible {
  animation: fade-in 0.8s ease-out forwards;
}

@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-in-left {
  from {
    opacity: 0;
    transform: translateX(-60px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slide-in-right {
  from {
    opacity: 0;
    transform: translateX(60px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes zoom-in {
  from {
    opacity: 0;
    transform: scale(0.7);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes scale-in-center {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .business-section {
    padding: 60px 0;
  }

  .business-section .section-title {
    font-size: 28px;
  }

  .business-card {
    height: 300px;
  }

  .business-card-title-inner {
    padding: 20px;
  }

  .business-card-title-inner h3 {
    font-size: 18px;
  }

  .business-card-description p {
    font-size: 14px;
    padding: 40px 20px 30px 20px;
  }

  .it-business-section {
    padding: 60px 0;
  }

  .it-business-header {
    margin-bottom: 40px;
    padding: 0 10px;
  }

  .it-business-section-title {
    font-size: 28px;
  }

  .it-business-subtitle {
    font-size: 15px;
  }

  .it-business-grid {
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 10px;
    gap: 0;
  }

  .it-business-panel {
    height: 280px;
    flex: 0 0 220px;
    min-width: 220px;
    width: 220px;
    scroll-snap-align: start;
  }

  .it-business-panel:hover {
    flex: 0 0 280px;
    width: 280px;
    min-width: 280px;
  }

  .it-business-grid:hover .it-business-panel:not(:hover) {
    flex: 0 0 180px;
    width: 180px;
    min-width: 180px;
  }

  .it-business-title-vertical {
    font-size: 16px;
  }

  .it-business-title-horizontal {
    font-size: 16px;
    top: 20px;
    left: 20px;
    right: 20px;
  }

  .it-business-details {
    padding: 20px;
  }

  .it-business-detail-label {
    font-size: 12px;
  }

  .it-business-detail-text {
    font-size: 13px;
  }


  .news-section-title {
    font-size: 28px;
  }

  .it-business-section {
    padding: 60px 0;
  }

  .it-business-header {
    margin-bottom: 50px;
    padding: 0 15px;
  }

  .it-business-section-title {
    font-size: 32px;
  }

  .it-business-subtitle {
    font-size: 16px;
  }

  .it-business-grid {
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    gap: 0;
  }

  .it-business-grid::-webkit-scrollbar {
    height: 6px;
  }

  .it-business-grid::-webkit-scrollbar-track {
    background: rgba(76, 149, 227, 0.1);
    border-radius: 3px;
  }

  .it-business-grid::-webkit-scrollbar-thumb {
    background: rgba(76, 149, 227, 0.5);
    border-radius: 3px;
  }

  .it-business-panel {
    height: 300px;
    flex: 0 0 250px;
    min-width: 250px;
    width: 250px;
    scroll-snap-align: start;
  }

  .it-business-panel:hover {
    flex: 0 0 300px;
    width: 300px;
    min-width: 300px;
  }

  .it-business-grid:hover .it-business-panel:not(:hover) {
    flex: 0 0 200px;
    width: 200px;
    min-width: 200px;
  }

  .it-business-title-vertical {
    font-size: 14px;
  }

  .it-business-title-horizontal {
    font-size: 14px;
    top: 15px;
    left: 15px;
    right: 15px;
  }

  .it-business-details {
    padding: 15px;
  }

  .it-business-detail-label {
    font-size: 11px;
  }

  .it-business-detail-text {
    font-size: 12px;
  }

  .news-content-wrapper {
    grid-template-columns: 1fr;
    gap: 24px;
    margin-bottom: 30px;
  }

  .news-featured {
    margin-bottom: 20px;
  }

  .featured-image {
    height: 250px;
  }

  .featured-content {
    padding: 20px;
  }

  .featured-title {
    font-size: 18px;
  }

  .featured-summary {
    font-size: 14px;
  }

  .news-item {
    flex-direction: column;
    padding: 15px;
    gap: 12px;
  }

  .news-date {
    width: auto;
    flex-direction: row;
    justify-content: center;
    gap: 8px;
    padding: 10px;
  }

  .date-day {
    font-size: 24px;
  }

  .date-year-month {
    font-size: 12px;
    margin-top: 0;
    margin-left: 8px;
  }

  .news-content h3 {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .news-summary {
    font-size: 12px;
  }

  .section-title {
    font-size: 26px;
  }

}

@media (max-width: 400px) {
  .container {
    padding: 20px 10px;
  }

  .news-section {
    overflow-x: hidden;
  }

  .news-content-wrapper {
    gap: 20px;
    margin-bottom: 20px;
  }

  .news-featured {
    margin-bottom: 15px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .featured-image {
    height: 200px;
    width: 100%;
    box-sizing: border-box;
  }

  .featured-content {
    padding: 15px;
    width: 100%;
    box-sizing: border-box;
  }

  .featured-title {
    font-size: 16px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .featured-summary {
    font-size: 13px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .news-list-wrapper {
    width: 100%;
    box-sizing: border-box;
  }

  .news-list {
    width: 100%;
    box-sizing: border-box;
  }

  .news-item {
    padding: 12px;
    gap: 10px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .news-date {
    padding: 8px;
    gap: 6px;
    box-sizing: border-box;
  }

  .date-day {
    font-size: 20px;
  }

  .date-year-month {
    font-size: 11px;
  }

  .news-content {
    width: 100%;
    box-sizing: border-box;
    min-width: 0;
  }

  .news-content h3 {
    font-size: 13px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }

  .news-summary {
    font-size: 11px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .section-title {
    font-size: 22px;
  }

  .news-section-title {
    font-size: 22px;
  }

  .news-subtitle {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .network-security-section {
    padding: 40px 0 30px;
  }

  .network-security-header .module-title {
    font-size: 26px;
  }

  .network-security-header .module-subtitle {
    font-size: 16px;
  }

  .network-security-timeline {
    padding-top: 0;
  }

  .timeline-items {
    position: static;
    height: auto;
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .timeline-item {
    position: static;
    width: 100%;
    min-width: auto;
    bottom: auto;
    left: auto;
    padding-bottom: 0;
    display: flex;
    align-items: flex-start;
    gap: 16px;
    text-align: left;
  }

  .timeline-node {
    position: static;
    left: auto;
    bottom: auto;
    transform: none;
    width: 80px;
    height: 80px;
    flex-shrink: 0;
  }

  .timeline-connector {
    display: none;
  }

  .timeline-panel {
    position: static;
    width: 100%;
    transform: none;
    margin-top: 0;
  }

  .timeline-panel h4 {
    font-size: 16px;
  }

  .timeline-panel p {
    font-size: 13px;
  }
}
</style>


